module.exports = __webpack_public_path__ + "c3fa0bcd86c455f3ef4b33ad155bb35e.svg";